<template>
  <div id="DeviceActiveTopTen">
  </div>
</template>

<script>
import resize from '../echarts/mixins/resize'
import * as echarts from 'echarts'
import common from '@/mixins/common.js'
export default {
  mixins: [resize, common],
  name: 'DeviceActiveTopTen',
  props: [

  ],
  data () {
    let vThat = this
    var seriesLabel = {
      normal: {
        position: ['0%', -vThat.fontSizeRem(0.6)],
        show: true,
        textBorderColor: '#333',
        textBorderWidth: vThat.fontSizeRem(0.1),
        color: 'rgba(255,255,255,0.8)',
        textStyle: {
          fontSize: vThat.fontSizeRem(0.6)
        },
        formatter: function (value, index) {
          return vThat.names[value.dataIndex]
        }
      }
    }
    return {
      names: [
        '南山街道-南山地铁如家酒店LED屏',
        '西丽街道-天虹商场十字路口LED屏',
        '粤海街道-创业路党群服务中心社区屏',
        '粤海街道-海岸城东南门对面LED屏',
        '南山街道-向南社区党群中心社区屏',
        '蛇口街道-海上世界北三门LED屏',
        '蛇口街道-双玺花园三期社区屏',
        '西丽街道-丽湖社区党群中心社区屏',
        '沙河街道--荔枝苑东区社区屏',
        '沙河街道-党群服务中心社区屏'
      ],
      chart: null,
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: '0%',
          top: '2%',
          right: '10%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [{
          type: 'value',
          show: false,
          axisLine: {
            show: false
          }
        }],
        yAxis: [
          {
            type: 'category',
            inverse: true,
            data: [
              '1', '2', '3', '4', '5', '6', '7', '', '', ''
            ],
            show: false,
            boundaryGap: [10, 10],
            inverval: 10,
            axisLine: {
              show: false
            }
          },
          {
            type: 'category',
            inverse: false,
            data: ['15192次', '15920次', '16692次', '16728次', '16920次', '17212次', '17290次', '18902次', '19203次', '20103次'],
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: vThat.fontSizeRem(0.8)
              }
            },
            axisTick: {
              show: false
            }
          }],
        series: [
          {
            type: 'bar',
            data: [20103, 19203, 18902, 17290, 17212, 16920, 16728, 16692, 15920, 15192],
            label: seriesLabel,
            barWidth: 10,
            itemStyle: {
              normal: {
                // color: new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }]),
                color: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#01C7E5' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#042CF3' // 100% 处的颜色
                  }]
                }
              }
            }
          }
        ]
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      this.initEchart()
    })
  },
  watch: {

  },
  methods: {
    initEchart () {
      let mapDiv = document.getElementById('DeviceActiveTopTen')
      this.chart = echarts.init(mapDiv, {}, { renderer: 'svg' })
      this.chart && this.chart.setOption(this.options)
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
#DeviceActiveTopTen
  height 24.5rem
</style>
